import { render, staticRenderFns } from "./xdf.vue?vue&type=template&id=8318eb40&scoped=true&"
import script from "./xdf.vue?vue&type=script&lang=js&"
export * from "./xdf.vue?vue&type=script&lang=js&"
import style0 from "./xdf.vue?vue&type=style&index=0&id=8318eb40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8318eb40",
  null
  
)

export default component.exports